/**
 * Show a contact form's success/error block ONLY on the form that actually posted.
 *
 * Shopify's `form.posted_successfully?` and `form.errors` are true inside EVERY
 * `{% form 'contact' %}` block on the page, not just the submitted one. A product page
 * renders five contact forms (four cc-pdf-capture slots + pdp-msg), so the quote form
 * announced "Thanks - we got your message" whenever anyone downloaded a PDF.
 *
 * Shopify anchors each form's action to its own id (`/contact#pdp-msg-...`), and that
 * hash survives the post-redirect, so it identifies the real submitter. It is readable
 * only client-side -- hence this file.
 *
 * Markup contract (see ops/form-schema.md):
 *   <div data-cc-form-success="<the form's id>" style="display:none"> ... </div>
 *   <div data-cc-form-error="<the form's id>"   style="display:none"> ... </div>
 * Inline display:none is deliberate -- the [hidden] attribute loses to the theme's
 * class-based `display:flex` rules on these blocks.
 */
(function () {
  'use strict';

  function reveal(el) {
    el.style.display = '';
    if (el.hasAttribute('data-cc-form-focus')) return;
    el.setAttribute('data-cc-form-focus', '1');
    try { el.focus({ preventScroll: false }); } catch (e) {}
  }

  function contactFormCount() {
    return document.querySelectorAll('form[action^="/contact"]').length;
  }

  function run() {
    var hash = (window.location.hash || '').replace(/^#/, '');
    var single = contactFormCount() === 1;

    ['success', 'error'].forEach(function (kind) {
      var attr = 'data-cc-form-' + kind;
      var blocks = document.querySelectorAll('[' + attr + ']');
      if (!blocks.length) return;

      var match = null;
      if (hash) {
        for (var i = 0; i < blocks.length; i++) {
          if (blocks[i].getAttribute(attr) === hash) { match = blocks[i]; break; }
        }
      }
      // With no hash we can only guess safely when the page has exactly one contact
      // form. Guessing on a multi-form page is the bug this file exists to fix.
      if (!match && !hash && single && blocks.length === 1) match = blocks[0];

      if (match) reveal(match);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
